// extracted by mini-css-extract-plugin
export default {"Container":"index_Container__q8o6E","Dymic":"index_Dymic__mfw+a","Num":"index_Num__WlWoa"};